const API_URL = process.env.REACT_APP_API_URL;
const STORAGE_KEY = 'bela-guest-preview-state';
const DEFAULT_GREETING = [
  {
    role: 'assistant',
    content: "Hi, I'm Bela. Happy to tell you what this place is all about — or we can just talk. What are you curious about?",
  },
];

const createSessionId = () => `guest_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;

const canUseStorage = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export const getDefaultGuestPreviewState = () => ({
  sessionId: createSessionId(),
  messages: DEFAULT_GREETING,
  guestMessageCount: 0,
  wallReason: null,
  wallMessage: '',
});

export const loadGuestPreviewState = () => {
  if (!canUseStorage()) {
    return getDefaultGuestPreviewState();
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return getDefaultGuestPreviewState();
    }

    const parsed = JSON.parse(raw);

    return {
      ...getDefaultGuestPreviewState(),
      ...parsed,
      messages: Array.isArray(parsed?.messages) && parsed.messages.length > 0
        ? parsed.messages
        : DEFAULT_GREETING,
    };
  } catch (error) {
    console.error('Failed to load guest preview state:', error);
    return getDefaultGuestPreviewState();
  }
};

export const saveGuestPreviewState = (state) => {
  if (!canUseStorage()) {
    return;
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    console.error('Failed to save guest preview state:', error);
  }
};

export const clearGuestPreviewState = () => {
  if (!canUseStorage()) {
    return;
  }

  window.localStorage.removeItem(STORAGE_KEY);
};

export const sendGuestPreviewMessage = async ({ sessionId, messages, latestMessage, guestMessageCount }) => {
  const response = await fetch(`${API_URL}/ai/guest-preview`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      sessionId,
      messages,
      latestMessage,
      guestMessageCount,
      metadata: {
        page: window.location.pathname,
        source: 'landing',
        userAgent: navigator.userAgent,
      },
    }),
  });

  let payload;
  try {
    payload = await response.json();
  } catch (error) {
    throw new Error('Guest preview returned an unreadable response.');
  }

  if (!response.ok || !payload.success) {
    throw new Error(payload.error || 'Unable to send guest preview message.');
  }

  return payload.data;
};
